<template>  
<div> <!-- root element start -->
	<div class="row">
		<div class="col-12">
      <div v-if="userOrgComp == 0" class="card border-0">
          <div class="card-body">

            <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>

          </div>
      </div>
			<div v-if="userOrgComp == 1" class="card border-0">
			    <div class="card-header h5 bg-transparent border-0">Organization List</div>
			    <div class="card-body">

			    	<v-client-table :data="userOrgArray" :columns="tableColumns" :options="tableOptions">
                <div slot="orgSelect" slot-scope="props">
                	<a :href="detailUrl + props.row.id" class=""><i class="fa fa-search" aria-hidden="true"></i></a>
                </div>
             </v-client-table>

			    </div>
			</div>
		</div>
	</div>
</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/user-org-main-store.js'




export default {
  store,
  data: function () {
    return { 
      detailUrl: '/organization-detail/',
    	tableColumns: ['id', 'name', 'cntCnt', 'qtCnt', 'statusName', 'created_at', 'orgSelect'],
  		tableOptions: {
  			skin: 'table table-sm table-hover border-0 vuetable2',
  			filterable: true,
  			pagination: { chunk:4 },
  			perPageValues: [],
  			perPage: 18,
        dateColumns: ['created_at'],
        dateFormat: 'MM-DD-YYYY',
        toMomentFormat:  'YYYY-MM-DD H:mm:ss',
  			texts:{
  				filter:"",
  				count:"",
  				filterPlaceholder:"Search",
  				page:"Page:",
  				noResults:"No matching records",
  				loading:'Loading...',
  			},
  			columnsClasses: {
  				cntCnt: 'text-center noOutline',
  				qtCnt: 'text-center noOutline', 
  				statusName: 'text-center noOutline',
  				created_at: 'text-center ',
  			}, 
  			headings: { 
  				id: 'Ref',
  				name: 'Name',
  				cntCnt: 'Contacts',
  				qtCnt: 'Quotes', 
  				statusName: 'Status',
  				created_at: 'Created',
  				orgSelect: '',
  			},
  		}
    }
  },
  computed: {
    userOrgArray() { return this.$store.state.userOrgArray; },
    userOrgComp() { return this.$store.state.userOrgComp; }
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    
    
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },

  },    
  components:{
    ScalingSquaresSpinner,
    
  },
  filters: {

  }
}
</script>

